export const classNames = (...classes) => {
  const result = classes.filter(c => !!c).join(' ');
  return result;
}
export default classNames;